import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";
import { BaseUrl } from "../../../../Helper/BaseUrl";

// Get Table Data
export const WTPSecurityTableDataAPI = createAsyncThunk("WTPSecurityTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_PumpingStationID,
        M_UserID,
        token,
        From,
        To,
        Flag,

    } = data

    console.log("Flag", Flag)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (Flag == "House Keeping") {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_HouseKeeping_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_PumpingStationID=${M_WTP_PumpingStationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_Security_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_PumpingStationID=${M_WTP_PumpingStationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPSecurityTableDataSlice = createSlice({
    name: "WTPSecurityTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSecurityTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPSecurityTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPSecurityTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPSecurityTableDataReducer = WTPSecurityTableDataSlice.reducer



// Get Table Data
export const WTPSecurityTableDataAPIExport = createAsyncThunk("WTPSecurityTableDataExport", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_PumpingStationID,
        M_UserID,
        token,
        From,
        To,
        Flag,

    } = data

    console.log("Flag", Flag)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (Flag == "House Keeping") {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_HouseKeeping_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_PumpingStationID=${M_WTP_PumpingStationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_Security_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_PumpingStationID=${M_WTP_PumpingStationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPSecurityTableDataExportSlice = createSlice({
    name: "WTPSecurityTableDataExport",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSecurityTableDataAPIExport.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPSecurityTableDataAPIExport.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WTPSecurityTableDataAPIExport.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPSecurityTableDataExportReducer = WTPSecurityTableDataExportSlice.reducer


// Get Table Data
export const WTPSecurityExportTableDataAPI = createAsyncThunk("WTPSecurityExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_PumpingStationID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_Security_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_PumpingStationID=${M_WTP_PumpingStationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPSecurityExportTableDataSlice = createSlice({
    name: "WTPSecurityExportTableData",
    initialState: {
        isExportLoading: false,
        GardenExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSecurityExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPSecurityExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.GardenExporttableData = action.payload;
        });
        builder.addCase(WTPSecurityExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.GardenExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPSecurityExportTableDataReducer = WTPSecurityExportTableDataSlice.reducer

// Delete Table Data

export const WTPSecurityDeleteAPI = createAsyncThunk("WTPSecurityDelete", async ({ data }) => {

    const {
        T_WTP_SecurityID,
        T_WTP_HouseKeepingID,
        M_UserID,
        handleIsPost,
        token,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (Flag == "HouseKeeping") {
        formdata.append("T_WTP_HouseKeepingID", T_WTP_HouseKeepingID);
    } else {
        formdata.append("T_WTP_SecurityID", T_WTP_SecurityID);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url

    if (Flag == "HouseKeeping") {
        url = `${BaseUrl}/APKDashboard/WEB_WTP_T_WTP_HouseKeeping_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WTP_T_WTP_Security_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WTPSecurityDeleteSlice = createSlice({
    name: "WTPSecurityDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSecurityDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPSecurityDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WTPSecurityDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPSecurityDeleteReducer = WTPSecurityDeleteSlice.reducer